/**
 * User: nir
 * Date: 06/09/2016
 * Time: 17:42
 */

if (window && window.jQuery) {
    window.jQuery(function ($) {
        // define the function
        window.TCT = window.TCT || {};
        window.TCT.loadHDImages = function () {
            var lowResImages = $("[data-HD]");

            lowResImages.each(function () {
                var target = $(this);
                var path = target.attr('data-hd');

                $('<img src="' + path + '">').load(function () {
                    target.css('background-image', 'url(' + path + ')');
                    lowResImages.removeAttr('data-HD');
                });
            });
        };

        // run on page load
        $(window).load(window.TCT.loadHDImages);
    });
}